import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function QADetail() {
  const { slug } = useParams();
  const [q, setQ] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/questions/${slug}`).then((r) => setQ(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err)
    return (
      <div className="container-reading py-24 text-center">
        <h1 className="heading-2">Question not found.</h1>
        <Link to="/questions" className="mt-6 btn-primary inline-flex">All Questions</Link>
      </div>
    );
  if (!q) return <div className="container-reading py-24 text-ink-muted">Loading…</div>;

  return (
    <article>
      <header className="bg-subtle border-b border-border py-16">
        <div className="container-reading">
          <Link to="/questions" className="inline-flex items-center gap-1 text-sm text-ink-muted hover:text-forest">
            <ChevronLeft className="h-4 w-4" /> Questions
          </Link>
          <p className="eyebrow mt-6 text-forest">{q.category}</p>
          <h1 className="heading-1 mt-3">{q.question}</h1>
        </div>
      </header>
      <div className="container-reading py-16">
        <div className="border-l-2 border-gold pl-6">
          <p className="eyebrow">Direct answer</p>
          <p className="lead mt-3">{q.short_answer}</p>
        </div>
        <div className="prose-editorial mt-10" dangerouslySetInnerHTML={{ __html: q.long_answer }} />
        {q.scriptures?.length > 0 && (
          <div className="mt-10">
            <p className="eyebrow">Related passages</p>
            <p className="mt-2 body-copy">{q.scriptures.join(" · ")}</p>
          </div>
        )}
      </div>
    </article>
  );
}
